import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Nav from "@/components/sections/Nav";
import Intro from "@/components/sections/Intro";
import Hero from "@/components/sections/Hero";
import EditorialMarquee from "@/components/sections/EditorialMarquee";
import Manifesto from "@/components/sections/Manifesto";
import Services from "@/components/sections/Services";
import GettingStarted from "@/components/sections/GettingStarted";
import Showcase from "@/components/sections/Showcase";
import Testimonials from "@/components/sections/Testimonials";
import Apply from "@/components/sections/Apply";
import Footer from "@/components/sections/Footer";
import MobileSplash from "@/components/MobileSplash";

const HERO_VIDEO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_model-workspace-1/artifacts/a5s4rpjo_15526546-hd_1080_1920_30fps.mp4";

const SHOWCASE_MEDIA = [
  { type: "video", src: "https://customer-assets-eiarnc6j.emergentagent.net/job_model-workspace-1/artifacts/unj53t0k_5977439-uhd_4096_2160_24fps.mp4" },
  { type: "image", src: "https://images.unsplash.com/photo-1650464595868-fd12e3047d33" },
  { type: "video", src: "https://customer-assets-eiarnc6j.emergentagent.net/job_model-workspace-1/artifacts/g8bf44jv_15520323_1920_1080_25fps.mp4" },
  { type: "video", src: "https://customer-assets-eiarnc6j.emergentagent.net/job_model-workspace-1/artifacts/se3icrlz_15520309_1920_1080_25fps.mp4" },
];

const APPLY_VIDEO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_model-workspace-1/artifacts/i4vjag0k_15839862_2160_3840_24fps.mp4";

export default function Home() {
  const navigate = useNavigate();
  const [introDone, setIntroDone] = useState(false);

  // Any "Get Scouted" CTA on any device routes to the dedicated /get-scouted page.
  const handleApply = () => navigate("/get-scouted");

  return (
    <>
      <AnimatePresence>
        {!introDone && <Intro key="intro" onFinish={() => setIntroDone(true)} />}
      </AnimatePresence>

      {introDone && (
        <MobileSplash onGetScouted={() => navigate("/get-scouted")} />
      )}

      <main className="bg-[#0a0a0a]">
        <Nav onApply={handleApply} />
        <Hero heroVideo={HERO_VIDEO} onApply={handleApply} />
        <EditorialMarquee />
        <Manifesto />
        <Services />
        <GettingStarted />
        <Showcase media={SHOWCASE_MEDIA} onApply={handleApply} />
        <Testimonials />
        <Apply sidebarVideo={APPLY_VIDEO} />
        <Footer onApply={handleApply} />
      </main>
    </>
  );
}
